export default __webpack_public_path__ + "static/support-4607ce117ca933ccb7c53e9952ff3717.png";